// /TBS/frontend/src/routes/AdminRoute.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import API from "../helpers/API";
import AuthLoader from "../ui/Loader/AuthLoader";

// 🚨 THE CSS FIX: Import global admin styles here so they load once for all admin pages
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../Pages/Admin/assets/vendors/mdi/css/materialdesignicons.min.css";
import "../Pages/Admin/assets/vendors/ti-icons/css/themify-icons.css";
import "../Pages/Admin/assets/vendors/css/vendor.bundle.base.css";
import "../Pages/Admin/assets/vendors/font-awesome/css/font-awesome.min.css";
import "../Pages/Admin/assets/vendors/bootstrap-datepicker/bootstrap-datepicker.min.css";
import "../Pages/Admin/assets/css/style.css";
import initOffCanvas from "../Pages/Admin/assets/js/off-canvas";
import misc from "../Pages/Admin/assets/js/misc";
import settings from "../Pages/Admin/assets/js/settings";
import todolist from "../Pages/Admin/assets/js/todolist";

export const AdminRoute = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const authContext = useAuth();
  const [auth] = authContext;
  const { isAuthenticated, isInitialized, clearAuth, isTokenExpired } =
    authContext;
  const navigate = useNavigate();

  // Initialize Admin JS Scripts
  useEffect(() => {
    initOffCanvas();
    misc();
    settings();
    todolist();
  }, []);

  const checkAuthorization = useCallback(async () => {
    setIsLoading(true);
    if (isTokenExpired(auth.token)) {
      clearAuth();
      navigate("/Login", { replace: true });
      return;
    }
    try {
      const res = await API.get("/auth/adminRoute");
      setIsAuthorized(res.data?.ok === true);
    } catch (error) {
      if (error.response?.status === 401) {
        clearAuth();
        navigate("/Login", { replace: true });
      } else if (error.response?.status === 403) {
        navigate("/", { replace: true });
        setIsAuthorized(false);
      } else {
        setIsAuthorized(true);
      }
    } finally {
      setIsLoading(false);
    }
  }, [auth.token, navigate, clearAuth, isTokenExpired]);

  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      checkAuthorization();
    } else if (isInitialized && !isAuthenticated) {
      navigate("/Login", { replace: true });
    }
  }, [isInitialized, isAuthenticated, checkAuthorization, navigate]);

  if (!isInitialized || isLoading) {
    return <AuthLoader />;
  }

  return isAuthorized ? <Outlet /> : <AuthLoader />;
};
